import padStart from 'lodash/padStart';
/**
 * Formats a date in MM-DD-YYYY-HH-NN-SS
 *
 * @param {Date} date Date to format
 * @param {string} separator Separator, defaults to -
 * @returns {string} Formatted date string
 */
function getDateString(date, separator = '-') {
    try {
        return [
            padStart(date.getMonth() + 1, 2, '0'),
            padStart(date.getDate(), 2, '0'),
            date.getFullYear(),
            padStart(date.getHours(), 2, '0'),
            padStart(date.getMinutes(), 2, '0')
        ].join(separator);
    }
    catch {
        return '';
    }
}
/**
 * Returns a file name that has a base file name and a date or date range.
 * Useful for export kind of file names
 *
 *
 * @param {string} baseFileName  Base file name
 * @param {string} extension  extension File name extension. With or without leading dot.
 * @param {Date} start  Date to use as the starting date
 * @param {Date} [end] Date to use as an end date
 * @param {string} [separator=-] Separator to use. Defaults to -
 * @returns {string} Formatted file name with dates or date range
 */
export function getFileName(baseFileName, extension = '', start = new Date(), end, separator = '-') {
    if (extension && extension.length && extension[0] !== '.') {
        extension = `.${extension}`;
    }
    let dateRange = getDateString(start, separator);
    dateRange = end ? `${separator}${dateRange}${separator}${getDateString(end, separator)}` : `${separator}${dateRange}`;
    return `${baseFileName}${dateRange}${extension}`;
}
